import { isNil, negate, pickBy } from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const getNextLink = ({ barberRoute, giftCardAmount }, generateUrlString, anyBarber, brand) => {
  const query = {
    ...(anyBarber && { anyBarber }),
    ...(brand && { brand }),
  };

  return {
    pathname: generateUrlString(pickBy({ giftCardAmount, barberRoute }, negate(isNil))),
    query,
  };
};



// WEBPACK FOOTER //
// ./src/app/giftCard/helpers.js